var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmbarrased(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "2050px",
    height: "2050px",
    viewBox: "0 0 2050 2050",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#ffc500;}.cls-3{fill:#ff9f1e;}.cls-4{fill:#ffe059;}.cls-5{fill:#ff4f4f;}.cls-6{fill:#00305f;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 2040,
    width: 2040,
    x: 5,
    y: 5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 3",
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 1025,
    cy: 1067.1,
    r: 613.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1068.5,1593.9c-339,0-613.7-274.8-613.7-613.7a613.5,613.5,0,0,1,44.4-229.8,611,611,0,0,0-87.9,316.7c0,338.9,274.8,613.7,613.7,613.7,257.7,0,478.3-158.8,569.2-383.9C1486.8,1474.9,1291.5,1593.9,1068.5,1593.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1025,453.4A611.1,611.1,0,0,0,659.9,573.8a706.9,706.9,0,0,1,453.2-18.9,27.8,27.8,0,0,0-3.3,5.1c-18.2,33.9,18.9,89.1,82.7,123.3s130.4,34.6,148.6.8a38.6,38.6,0,0,0,3.7-10.5c165.2,128.1,271.9,328.1,272.9,553.1a613.3,613.3,0,0,0,21-159.6C1638.7,728.2,1363.9,453.4,1025,453.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1478.1,706.5a30,30,0,0,1-30-30V514.4a30,30,0,0,1,60,0V676.5A30,30,0,0,1,1478.1,706.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1254.8,753.3a30,30,0,0,1-30-30v-162a30,30,0,0,1,60,0v162A30,30,0,0,1,1254.8,753.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1362.8,794.7a30.1,30.1,0,0,1-30-30V399.2a30,30,0,0,1,60,0V764.7A30,30,0,0,1,1362.8,794.7Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    height: 378.7,
    rx: 112.8,
    ry: 112.8,
    width: 225.7,
    x: 912.2,
    y: 1114
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M771,1037.1c-64.7,0-117.4-52.7-117.4-117.5A117.6,117.6,0,0,1,771,802.2c64.8,0,117.5,52.7,117.5,117.4A117.6,117.6,0,0,1,771,1037.1Zm0-174.9a57.5,57.5,0,1,0,57.5,57.4A57.4,57.4,0,0,0,771,862.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1279,1037.1a117.6,117.6,0,0,1-117.5-117.5c0-64.7,52.7-117.4,117.5-117.4a117.6,117.6,0,0,1,117.4,117.4C1396.4,984.4,1343.7,1037.1,1279,1037.1Zm0-174.9a57.5,57.5,0,1,0,57.4,57.4A57.5,57.5,0,0,0,1279,862.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1025,1305.9a280.8,280.8,0,0,0-112.8,23.5v50.5A112.8,112.8,0,0,0,1025,1492.7h0a112.8,112.8,0,0,0,112.8-112.8v-50.5A280.8,280.8,0,0,0,1025,1305.9Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmbarrased);
export default __webpack_public_path__ + "static/media/embarrased.9302d0553456da0278180a19167777fb.svg";
export { ForwardRef as ReactComponent };